import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// State
import { addToCart, fetchGiftsIsNeeded } from '../../state/modules/sailplay/actions';

export default function useGiftsSlider() {
  const dispatch = useDispatch();
  const gifts = useSelector(state => state.sailplay.gifts);
  const [isLoading, setIsLoading] = useState([]);

  const onAddClick = useCallback(async gift => {
    setIsLoading(prev => [...prev, gift.sku]);
    await dispatch(addToCart(gift.sku, [{ type: 'bonus', item: gift.item }]));
    setIsLoading(prev => prev.filter(prevSku => prevSku !== gift.sku));
  }, []);

  useEffect(() => {
    dispatch(fetchGiftsIsNeeded());
  }, []);

  return { gifts, isLoading, onAddClick };
}
